import { createToObject } from 'pricing-pages-ui-components/utils/queryParamUtils';
import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Metrics } from '../utils/metrics';
import { useHubSpotCreditsPageRedirect } from '../v2/hooks/gating/useHubSpotCreditsPageRedirect';
import { useIsPaidPortal } from '../v2/hooks/inventory/useProductInventory';
import { useIsInAppAuth } from '../v2/hooks/user/useUserInfo';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const HubSpotCreditsRedirect = ({
  children
}) => {
  const shouldRedirect = useHubSpotCreditsPageRedirect();
  const isInApp = useIsInAppAuth();
  const {
    isPaidPortal,
    loading
  } = useIsPaidPortal();
  const redirectPath = isInApp && isPaidPortal ? '/add-ons' : '/';
  useEffect(() => {
    if (shouldRedirect && !loading) {
      Metrics.counter('hubspot-credits-page-redirect', {
        redirectTo: redirectPath,
        referrer: document.referrer || 'direct'
      }).increment();
    }
  }, [shouldRedirect, loading, redirectPath]);
  if (!shouldRedirect) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  if (isInApp && loading) {
    return null;
  }
  return /*#__PURE__*/_jsx(Redirect, {
    to: createToObject(redirectPath)
  });
};